const Lang = require('lang');

function ChangeCostCenterReport() {
  const $form = $('#form-relatorio');

  if ($form.length < 1) {
    return;
  }

  const $idEmpresaPagante = $form.find('#idEmpresaPagante');
  const $centroCustoAlterado = $form.find('[name="centroCustoAlterado"]')[0];
  const buttonFormSubmit = document.querySelector('#buttonFormRelatorioSubmit');
  const idEmpresaPaganteSelectize = $idEmpresaPagante[0].selectize;

  // Change da input de centro de custo
  $idEmpresaPagante.on('change', function () {
    const idCostCenter = idEmpresaPaganteSelectize.getValue();
    if (!isApprovalByCostCenter($idEmpresaPagante)) {
      return;
    }

    if (!isReportContainExpenses($idEmpresaPagante)) {
      return;
    }

    if (!isChangedCostCenter($idEmpresaPagante, idCostCenter)) {
      $centroCustoAlterado.value = 0;
      return;
    }
    $centroCustoAlterado.value = 1;
  });

  // Click do botão para submter o formulario
  buttonFormSubmit.addEventListener('click', function () {
    if ($centroCustoAlterado.value == '0') {
      $form.trigger('submit');
      return;
    }

    showConfirmation($form, $idEmpresaPagante, idEmpresaPaganteSelectize);
  });
}

/**
 * Verificar se o tipo de apravação é por centro
 * de custo
 *
 * @param  {Element}  $idEmpresaPagante
 *
 * @return {Boolean}
 */
function isApprovalByCostCenter($idEmpresaPagante) {
  const approvalType = $idEmpresaPagante[0].getAttribute('data-approval-type');
  if (approvalType == 'CC') {
    return true;
  }
  return false;
}

/**
 * Verificar se o relatório contém despesas
 *
 * @param  {element}  $idEmpresaPagante
 *
 * @return {Boolean}
 */
function isReportContainExpenses($idEmpresaPagante) {
  const countExpenses = $idEmpresaPagante[0].getAttribute('data-expenses-count');
  if (parseInt(countExpenses) > 0) {
    return true;
  }
  return false;
}

/**
 * Verificar se foi alterado o valor do centro de custo
 *
 * @param  {element}  $idEmpresaPagante
 * @param  {id}  currentCostCenter
 *
 * @return {Boolean}
 */
function isChangedCostCenter($idEmpresaPagante, currentCostCenter) {
  const oldCostCenter = $idEmpresaPagante[0].getAttribute('data-report-cost-center');
  if (oldCostCenter != currentCostCenter) {
    return true;
  }
  return false;
}

/**
 * Show modal para confirmar se deseja que todas as despesas
 * tenham seus centro de custos alterados
 *
 * @param  {element} $form
 * @param  {element} $idEmpresaPagante
 * @param  {element} idEmpresaPaganteSelectize [description]
 */
function showConfirmation($form, $idEmpresaPagante, idEmpresaPaganteSelectize) {
  bootbox.confirm({
    title: Lang.get('js/src/functions/ChangeCostCenterReport.title_modal_confirm'),
    message: Lang.get('js/src/functions/ChangeCostCenterReport.message_modal_confirm'),
    buttons: {
      confirm: {
        label: Lang.get('js/common/words.yes'),
        className: 'btn-success',
      },
      cancel: {
        label: Lang.get('js/common/words.cancel'),
        className: 'btn-danger'
      }
    },
    callback: function (result) {
      if (result) {
        $form.trigger('submit');
        return;
      }
      noChangeCostCenter($idEmpresaPagante, idEmpresaPaganteSelectize);
    }
  });
}

/**
 * Retornar o valor do select box de centro de custo
 * para o mesmo valor que ele tinha antes
 * @param  {element} $idEmpresaPagante
 * @param  {element} idEmpresaPaganteSelectize
 */
function noChangeCostCenter($idEmpresaPagante, idEmpresaPaganteSelectize) {
  const oldCostCenter = $idEmpresaPagante[0].getAttribute('data-report-cost-center');
  idEmpresaPaganteSelectize.setValue(oldCostCenter);
}

module.exports = {
  init: function init() {
    ChangeCostCenterReport();
  }
};
